// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kf-1";
export var messageSideRight = "_kf-2";
export var subscribeToBackInStockBubbleContainer = "_kf-0";